import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-34-kapil-shelke-guest.webp";
import ThumbImg from "../../assets/images/conversations/034.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: ks-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ks-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .ks-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .ks-hero { padding-top: 60px; padding-bottom: 60px; }
  .ks-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ks-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .ks-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ks-hero__title.ks-visible { opacity: 1; transform: translateY(0); }
  .ks-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ks-hero__spotify.ks-visible { opacity: 1; transform: translateY(0); }
  .ks-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .ks-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ks-hero__right.ks-visible { opacity: 1; transform: translateY(0); }

  .ks-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .ks-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .ks-yt-thumb:hover img { opacity: 0.85; }
  .ks-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ks-yt-thumb__play img { width: 40px; height: 44px; }
  .ks-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .ks-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .ks-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ks-body.ks-visible { opacity: 1; transform: translateY(0); }
  .ks-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .ks-body__para:last-child { margin-bottom: 0; }

  .ks-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ks-guest.ks-visible { opacity: 1; transform: translateY(0); }
  .ks-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .ks-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .ks-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .ks-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ks-inner { padding-left: 32px; padding-right: 32px; }
    .ks-hero { padding-top: 32px; padding-bottom: 48px; }
    .ks-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ks-hero__title { font-size: 24px; }
    .ks-hero__left { gap: 16px; }
    .ks-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ks-guest__photo-bg { width: 260px; height: 300px; }
    .ks-guest__name { font-size: 24px; margin-top: 18px; }
    .ks-body__para { font-size: 14px; margin-bottom: 12px; }
    .ks-body { padding-bottom: 48px; }
    .ks-guest { padding-bottom: 48px; }
    .ks-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ks-inner { padding-left: 16px; padding-right: 16px; }
    .ks-hero { padding-top: 51px; padding-bottom: 30px; }
    .ks-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .ks-hero__left { gap: 30px; }
    .ks-hero__title { font-size: 30px; }
    .ks-body__para { font-size: 16px; margin-bottom: 10px; }
    .ks-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ks-guest__photo-bg { width: 100%; height: 386px; }
    .ks-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .ks-body { padding-bottom: 30px; }
    .ks-guest { padding-bottom: 30px; }
    .ks-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ks-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "3a_314IfFsc";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="ks-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 34 Kapil Shelke"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="ks-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 34 Kapil Shelke thumbnail" />
      <div className="ks-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ks-hero">
      <div className="ks-inner">
        <div className="ks-hero__grid">
          <div className="ks-hero__left">
            <h1 ref={titleRef} className="ks-hero__title">
              EP 34 | Revolutionizing the Electric Experience: An Inside Look at Tork's Vision | Kapil Shelke
            </h1>
            <div ref={spotifyRef} className="ks-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0YDRXzAqOwYGGOBRlfN1UE?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 34 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ks-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ks-body">
      <div className="ks-inner">
        <p className="ks-body__para">
          More often than not, we speak with people who bring to India a brilliant idea or technology from overseas. Today, our show features a subtle difference as we speak with the founder and CEO of a company that is swimming furiously against the trend. While the market is flooded with electric scooters being assembled by a myriad of companies in India, this company is making a fast, furious, and sexy electric motorcycle. They are producing a world-class product for consumers, designed and made here in India. In this episode, we speak with Kapil SHELKE, Founder &amp; CEO at Tork Motors.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ks-guest">
      <div className="ks-inner">
        <h2 className="ks-guest__title">Our Guest</h2>
        <div>
          <div className="ks-guest__photo-bg">
            <img src={GuestImg} alt="Kapil Shelke" />
          </div>
          <p className="ks-guest__name">Kapil Shelke</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep34KapilShelke() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ks-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}